var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobsHeroLifelinesMobile = function SvgJobsHeroLifelinesMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 842,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 375 842"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 375,
    height: 842,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h375v842H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#EF737A",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.455 738.324c-10.864 19.418-11.905 47.403 1.397 69.105 20.478 33.414 63.255 38.104 94.701 28.126 60.686-19.25 102.452-74.534 132.487-133.875 30.024-59.345 51.392-125.013 86.866-180.1 39.367-61.115 95.763-107.601 161.424-133.044 67.429-26.13 144.8-30.843 204.461-71.512 29.169-19.886 54.599-54.447 45.599-94.895-6.98-31.362-34.3-57.396-62.779-65.858-28.477-8.453-57.27-1.561-80.597 12.705s-41.975 35.411-59.796 56.867c-73.645 88.628-137.987 186.538-212.339 274.433-36.135 42.71-74.762 83.019-117.292 118.21-21.164 17.509-43.298 33.731-66.482 48.222-21.527 13.449-45.346 29.805-70.532 35.647-23.919 5.544-43.894 12.348-57.114 35.977zM142.229-2c8.532 7.02 18.431 12.512 28.832 16.216 22.259 7.932 46.644 8.33 70.026 4.898C265.728 15.494 289.143 7.898 311.802-2M-1.23 99.783c18.505-7.486 36.319-13.068 52.69-14.757 95.037-9.801 138.27 20.215 233.752 19.303 25.488-.242 51.656-3.044 74.549-12.566 5.906-2.457 12.063-5.942 18.08-10.098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.61 604.05c32.131-63.634 110.67-83.598 208.439-92.561 116.913-10.717 263.859-106.515 201.177-258.36C323.094 86.191 30.81 101.964-4.054 125.732"
  }))));
};
export default SvgJobsHeroLifelinesMobile;